module.exports = __webpack_public_path__ + "img/二维码@2x.67951195.png";